import { render, staticRenderFns } from "./Attempt3.vue?vue&type=template&id=b4a84e2c&scoped=true&"
import script from "./Attempt3.vue?vue&type=script&lang=js&"
export * from "./Attempt3.vue?vue&type=script&lang=js&"
import style0 from "./Attempt3.vue?vue&type=style&index=0&id=b4a84e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a84e2c",
  null
  
)

component.options.__file = "Attempt3.vue"
export default component.exports